import { render, staticRenderFns } from "./TenancyApplicationForm.vue?vue&type=template&id=7b884bf2&scoped=true&"
import script from "./TenancyApplicationForm.vue?vue&type=script&lang=ts&"
export * from "./TenancyApplicationForm.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7b884bf2",
  null
  
)

export default component.exports